import React from 'react';
import classes from './GalleryHeader.module.css'


const galleryHeader = (props) => (
    <div className={classes.galleryHeader}>
        <h1>Gallery</h1>
        <p>Current session's screencaps. Older screencaps in Feedback.</p>
        <hr />
    </div>

)

export default galleryHeader;